











































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import { convertAvailableString } from '~/plugins/libs/convertString';

export default defineComponent({
  components: {
    AppIcon,
  },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    /** 入力値 */
    value: {
      type: [String, Number],
      default: '',
    },
    /** VeeValidateのバリデーションルール */
    rules: {
      type: [String, Object],
      default: null,
    },
    /** VeeValidateのバリデーションID */
    vid: {
      type: String,
      default: null,
    },
    /** VeeValidateのフィールドラベル */
    fieldName: {
      type: String,
      default: null,
    },
    /** a11y 読み上げラベル */
    ariaLabel: {
      type: String,
      default: null,
    },
    /** a11y 読み上げ対象要素のID */
    ariaLabelledby: {
      type: String,
      default: null,
    },
    /** プレースホルダ */
    placeholder: {
      type: String,
      default: '',
    },
    /** 入力型 */
    type: {
      type: String,
      default: 'text',
    },
    inputClass: {
      type: String,
      default: null,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    /** 禁則文字の変換フラグ */
    isConvertible: {
      type: Boolean,
      default: false,
    },
    /** 入力モード（SPキーボード） */
    inputMode: {
      type: String,
      default: null,
    },
    /** 埋めるための自動支援 */
    autocomplete: {
      type: String,
      default: null,
    },
    /**
     * バリデーションのタイミング。デフォルトはaggressive
     * @see https://vee-validate.logaretm.com/v3/guide/interaction-and-ux.html#setting-the-interaction-mode-per-component
     */
    mode: {
      type: String,
      default: 'aggressive',
    },
  },
  setup(props, { emit }) {
    const isTextVisible = ref(false);
    const inputRef = ref<HTMLInputElement>();
    const localValue = computed({
      get() {
        return props.value;
      },
      set(value: string | number) {
        emit('input', value);
      },
    });
    const emitInput = (event: { target: HTMLInputElement }) => {
      emit('input', event.target.value);
    };
    // 禁則文字の変換
    const convertString = (event: { target: HTMLInputElement }) => {
      if (props.isConvertible) {
        emit('input', convertAvailableString(event.target.value));
      } else {
        emit('blur', event.target.value);
      }
    };

    return {
      isTextVisible,
      inputRef,
      localValue,
      emitInput,
      convertString,
    };
  },
});
